
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.917 19.499H.75a.75.75 0 010-1.5h2.637a10.493 10.493 0 01-1.875-6.22 10.433 10.433 0 013.237-7.358 10.46 10.46 0 017.265-2.916c1.388 0 2.743.271 4.027.804a.748.748 0 01-.288 1.442.734.734 0 01-.288-.058 8.95 8.95 0 00-3.451-.689 8.967 8.967 0 00-6.228 2.5 8.943 8.943 0 00-2.775 6.307A8.976 8.976 0 004.5 16.969v-2.721a.75.75 0 111.5.001v4.5a.75.75 0 01-.75.75h-.238a.364.364 0 01-.045.003l-.05-.003zM11.995 22.501c-1.392 0-2.75-.272-4.038-.808a.747.747 0 01-.404-.981.748.748 0 01.98-.405 8.961 8.961 0 003.462.694 8.96 8.96 0 006.234-2.508 8.941 8.941 0 002.767-6.31 8.973 8.973 0 00-1.497-5.158v2.724a.75.75 0 01-1.499 0v-4.5a.75.75 0 01.75-.75h4.5a.75.75 0 010 1.5h-2.635a10.503 10.503 0 011.882 6.215 10.438 10.438 0 01-3.228 7.362 10.46 10.46 0 01-7.274 2.925z"}})])
          )
        }
      }
    